export default "__VITE_ASSET__BR1rO1HK__"